import { content } from '@/features/visualizer/content';
import { VisualizerPage } from '@/features/visualizer/VisualizerPage';
import { absoluteUrl } from '@/lib/config';
import { useT } from '@/lib/i18n';
import { Seo } from '@/lib/seo';

/** `/visualizer` — "See it in your space": pick a scene and a granite and see the stone applied. */
export function Component() {
  const copy = content;
  const t = useT();
  return (
    <>
      <Seo
        title={copy.seo.title}
        description={copy.seo.description}
        path="/visualizer"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: t('nav.home'), item: absoluteUrl('/') },
              {
                '@type': 'ListItem',
                position: 2,
                name: t('nav.visualizer'),
                item: absoluteUrl('/visualizer'),
              },
            ],
          },
        ]}
      />
      <VisualizerPage />
    </>
  );
}
